import * as React from "react";
import styled from "styled-components";
import { StyledTripSegment, StyledTripSegmentMilestone } from "../TripSegment";
import defaultTheme from "../defaultTheme";
import { left, right } from "../utils/rtl";
var StyledTripSector = styled.div.withConfig({
  displayName: "TripSector__StyledTripSector",
  componentId: "v14xkf-0"
})(["display:flex;position:relative;width:100%;padding-", ":2px;box-sizing:border-box;flex-direction:column;font-family:", ";&:before{content:\" \";display:block;position:absolute;background-color:", ";width:1px;height:100%;", ":7px;top:0;}", ":last-child{position:relative;", ":after{content:\" \";position:absolute;top:13px;right:0;bottom:0;left:0;width:16px;background:", ";}}"], right, function (_ref) {
  var theme = _ref.theme;
  return theme.orbit.fontFamily;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.orbit.paletteCloudNormal;
}, left, StyledTripSegment, StyledTripSegmentMilestone, function (_ref3) {
  var theme = _ref3.theme;
  return theme.orbit.paletteWhite;
});
StyledTripSector.defaultProps = {
  theme: defaultTheme
};

var TripSector = function TripSector(_ref4) {
  var children = _ref4.children,
      dataTest = _ref4.dataTest;
  return React.createElement(StyledTripSector, {
    "data-test": dataTest
  }, children);
};

export default TripSector;
export { default as TripDate } from "./TripDate";
export { default as TripLayover } from "./TripLayover";